import { getJson } from "../util.js";
import { hasLoggedInCookie, apiGetHubInfo, apiSignup, urlApiChallengeV2, urlApiProfile, } from "../api.js";
const A = "#C8A050";
const T = "#C0BAA8";
const TD = "#7a7468";
const ER = "#CC6666";
const TB = "#E0D8C0";
const BODY_LETTER_SPACING = "0.012em";
async function solveChallengesInWorker(worker, challenges, difficultyBits) {
    return await new Promise((resolve, reject) => {
        const cleanup = () => {
            worker.onmessage = null;
            worker.onerror = null;
            worker.onmessageerror = null;
        };
        worker.onmessage = (event) => {
            const data = event.data;
            if (typeof data !== "object" || data === null)
                return;
            const type = data.type;
            if (type === "solved") {
                cleanup();
                resolve(data.nonces);
            }
            else if (type === "error") {
                cleanup();
                reject(new Error(String(data.message)));
            }
        };
        worker.onerror = (event) => {
            cleanup();
            reject(new Error(event.message));
        };
        worker.onmessageerror = () => {
            cleanup();
            reject(new Error("Worker message error"));
        };
        worker.postMessage({
            type: "solve",
            challenges,
            difficulty: difficultyBits,
        });
    });
}
const SPINNER_FRAMES = ["⠋", "⠙", "⠹", "⠸", "⠼", "⠴", "⠦", "⠧", "⠇", "⠏"];
function createColoredSpan(text, color) {
    const span = document.createElement("span");
    span.style.color = color;
    span.textContent = text;
    return span;
}
function createParagraph(...nodes) {
    const paragraph = document.createElement("p");
    paragraph.style.margin = "0";
    paragraph.append(...nodes);
    return paragraph;
}
function updateHubCreationCopy(hubName) {
    const copy = document.getElementById("create-hub-copy");
    if (!copy)
        return;
    const firstParagraphNodes = [
        document.createTextNode("Хаб с именем "),
    ];
    if (hubName) {
        firstParagraphNodes.push(createColoredSpan(hubName, TB));
    }
    firstParagraphNodes.push(document.createTextNode(" был успешно создан. Имя является уникальным идентификатором и генерируется автоматически. "), document.createTextNode("Подготовлены персональные API ключи и файлы конфигурации."));
    copy.replaceChildren(createParagraph(...firstParagraphNodes), createParagraph(document.createTextNode("Вы успешно аутентифицированы, перейдите в личный кабинет по кнопке ниже или продолжите настройку здесь.")));
}
function updateAgentSetupCopy() {
    const copy = document.getElementById("agent-setup-copy");
    if (!copy)
        return;
    copy.replaceChildren(createParagraph(document.createTextNode("Подготовлены персональные настройки Claude Code, Codex и OpenCode для интеграции с хабом.")), createParagraph(document.createTextNode("Настройте ваших агентов по инструкции ниже, достаточно просто скопировать нужные секции.")));
}
export function addHubCreation() {
    const btn = document.getElementById("create-hub-btn");
    const output = document.getElementById("hub-creation-output");
    if (!btn || !output)
        return;
    if (hasLoggedInCookie()) {
        btn.style.display = "none";
        output.style.display = "block";
        void loadExistingHub(output);
        return;
    }
    btn.addEventListener("click", () => {
        void run(btn, output);
    });
}
export function syncHubCreationSuccessUi() {
    const btn = document.getElementById("create-hub-btn");
    const output = document.getElementById("hub-creation-output");
    if (!btn || !output)
        return;
    btn.style.display = "none";
    output.style.display = "block";
    output.replaceChildren();
    showSuccess(output);
}
export async function createHub(options = {}) {
    let worker = null;
    options.onPhaseChange?.("Подготовка");
    try {
        const challenge = await getJson(urlApiChallengeV2);
        options.onPhaseChange?.("Выполнение Proof of Work");
        worker = new Worker("/modules/entrypoints/pow-worker.js", {
            type: "module",
        });
        const nonces = await solveChallengesInWorker(worker, challenge.challenges, challenge.difficulty).finally(() => {
            worker?.terminate();
            worker = null;
        });
        options.onPhaseChange?.("Создание аккаунта");
        await apiSignup({ nonces });
        options.onPhaseChange?.("Загрузка хаба");
        const profile = await getJson(urlApiProfile);
        const hubInfo = await apiGetHubInfo(profile.personal_hub_id);
        updateHubNameLink(hubInfo.hub_name);
        updateHubCreationCopy(hubInfo.hub_name);
        updateAgentSetupCopy();
        const apiKey = hubInfo.agent_tokens[0]?.token ?? "";
        if (apiKey) {
            replaceKeyPlaceholders(apiKey);
        }
        syncHubCreationSuccessUi();
        document.dispatchEvent(new CustomEvent("hub-for-programmers:hub-created"));
        return hubInfo;
    }
    finally {
        worker?.terminate();
    }
}
function updateHubNameLink(hubName) {
    const link = document.getElementById("hub-name-link");
    if (!link)
        return;
    if (!hubName) {
        link.textContent = "";
        link.style.display = "none";
        return;
    }
    link.textContent = hubName;
    link.style.display = "inline";
}
async function loadExistingHub(output) {
    try {
        const profile = await getJson(urlApiProfile);
        const hubInfo = await apiGetHubInfo(profile.personal_hub_id);
        updateHubNameLink(hubInfo.hub_name);
        updateHubCreationCopy(hubInfo.hub_name);
        updateAgentSetupCopy();
        const apiKey = hubInfo.agent_tokens[0]?.token ?? "";
        if (apiKey) {
            replaceKeyPlaceholders(apiKey);
        }
        showSuccess(output);
    }
    catch {
        updateHubNameLink("");
    }
}
async function run(btn, output) {
    btn.style.transition = "opacity 0.15s";
    btn.style.opacity = "0";
    btn.style.pointerEvents = "none";
    await new Promise((r) => setTimeout(r, 150));
    btn.style.display = "none";
    btn.style.transition = "";
    output.style.display = "block";
    output.replaceChildren();
    const statusEl = document.createElement("div");
    statusEl.style.cssText = `font-size:12px;line-height:1.5;font-family:inherit;`;
    output.appendChild(statusEl);
    let phase = "Подготовка";
    let spinIdx = 0;
    const tick = () => {
        spinIdx = (spinIdx + 1) % SPINNER_FRAMES.length;
        statusEl.replaceChildren(createColoredSpan(SPINNER_FRAMES[spinIdx] ?? "⠋", A), document.createTextNode("  "), createColoredSpan(phase, T), createColoredSpan("...", TD));
    };
    tick();
    const spinnerInterval = setInterval(tick, 80);
    try {
        await createHub({
            onPhaseChange(nextPhase) {
                phase = nextPhase;
            },
        });
        clearInterval(spinnerInterval);
        output.replaceChildren();
        showSuccess(output);
    }
    catch (err) {
        clearInterval(spinnerInterval);
        output.replaceChildren();
        const msg = err instanceof Error ? err.message : String(err);
        const errEl = document.createElement("div");
        errEl.style.cssText = `font-size:12px;line-height:1.5;font-family:inherit;`;
        errEl.replaceChildren(createColoredSpan("✗", ER), document.createTextNode("  "), createColoredSpan(msg, ER));
        output.appendChild(errEl);
        btn.style.display = "";
        await new Promise((r) => setTimeout(r, 10));
        btn.style.transition = "opacity 0.15s";
        btn.style.opacity = "1";
        btn.style.pointerEvents = "";
        btn.style.transition = "";
    }
}
function replaceKeyPlaceholders(apiKey) {
    const apiKeyPreview = (apiKey || "...").slice(-20);
    for (const el of document.querySelectorAll('[data-api-key="full"]')) {
        el.textContent = (el.textContent ?? "").replaceAll("sk-ci-...", apiKey);
    }
    for (const el of document.querySelectorAll('[data-api-key="preview"]')) {
        el.textContent = (el.textContent ?? "").replaceAll("sk-ci-...", apiKeyPreview);
    }
    for (const el of document.querySelectorAll('[data-api-key="full-value"]')) {
        el.textContent = apiKey;
    }
}
function showSuccess(container) {
    const linkEl = document.createElement("div");
    linkEl.style.cssText = `margin-top:18px;`;
    const link = document.createElement("a");
    link.href = "/?first-enter";
    link.style.cssText = `display:inline-block;border:1px solid ${A};color:${A};padding:7px 24px;font-family:inherit;font-size:11px;letter-spacing:0.12em;text-decoration:none;`;
    link.textContent = "Личный кабинет →";
    linkEl.appendChild(link);
    container.appendChild(linkEl);
    const note = document.createElement("p");
    note.style.cssText = `line-height:1.5;letter-spacing:${BODY_LETTER_SPACING};color:${TD};margin-top:18px;margin-bottom:0;`;
    note.textContent =
        "Для доступа с другого устройства нужно сохранить логин ссылку или QR код в личном кабинете.";
    container.appendChild(note);
}
